/* Aliabooks — Top horizontal filter bar (client-side) */
(function () {
  'use strict';

  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function init(){
    var root = document.querySelector('[data-ab-topfilter]');
    if (!root) return;

    var dataEl = document.getElementById('ab-products-data');
    if (!dataEl) return;

    var products;
    try { products = JSON.parse(dataEl.textContent || '[]'); }
    catch (e) { products = []; }

    // Find the product grid that follows the filter in the DOM
    var grid = document.querySelector('[data-contentlm-replace]') ||
               document.querySelector('.t4s-products');
    if (!grid) return;

    // Build handle → product-data lookup
    var byHandle = {};
    products.forEach(function(p){ byHandle[p.h] = p; });

    // Match DOM cards to handles
    var cards = grid.querySelectorAll('.t4s-product');
    var cardList = [];
    cards.forEach(function(card){
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle;
      try { handle = decodeURIComponent(m[1]); } catch (e) { handle = m[1]; }
      var data = byHandle[handle];
      if (!data) return;
      cardList.push({ el: card, handle: handle, tags: data.t || [], available: data.a, price: data.p });
    });

    // State: { age: Set, purpose: Set, format: Set, gender: Set, inStock: bool }
    var state = {
      age: new Set(),
      purpose: new Set(),
      format: new Set(),
      gender: new Set(),
      inStock: false
    };

    var pills = root.querySelectorAll('[data-ab-pill]');
    var chipsWrap = root.querySelector('[data-ab-chips]');
    var clearBtn  = root.querySelector('[data-ab-clear]');
    var stockCk   = root.querySelector('[data-ab-instock]');
    var mobileOpen  = root.querySelector('[data-ab-mobile-open]');
    var mobileClose = root.querySelector('[data-ab-mobile-close]');
    var backdrop    = root.querySelector('[data-ab-backdrop]');
    var totalCount  = root.querySelector('[data-ab-total-count]');

    function isMobile(){ return window.matchMedia('(max-width: 767px)').matches; }

    function openSheet(){
      root.classList.add('is-mobile-open');
      if (backdrop) backdrop.hidden = false;
      document.body.classList.add('ab-body-locked');
      if (mobileOpen) mobileOpen.setAttribute('aria-expanded','true');
    }
    function closeSheet(){
      root.classList.remove('is-mobile-open');
      if (backdrop) backdrop.hidden = true;
      document.body.classList.remove('ab-body-locked');
      if (mobileOpen) mobileOpen.setAttribute('aria-expanded','false');
      closeAllPills();
    }

    if (mobileOpen) mobileOpen.addEventListener('click', function(e){
      e.stopPropagation();
      if (root.classList.contains('is-mobile-open')) closeSheet();
      else openSheet();
    });
    if (mobileClose) mobileClose.addEventListener('click', closeSheet);
    if (backdrop) backdrop.addEventListener('click', closeSheet);

    // Dropdown open/close — on mobile allow multiple pills open (accordion); desktop single
    pills.forEach(function(pill){
      var btn = pill.querySelector('[data-ab-toggle]');
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        var wasOpen = pill.classList.contains('is-open');
        if (!isMobile()) closeAllPills();
        if (wasOpen){
          pill.classList.remove('is-open');
          btn.setAttribute('aria-expanded','false');
        } else {
          pill.classList.add('is-open');
          btn.setAttribute('aria-expanded','true');
        }
      });
    });

    document.addEventListener('click', function(e){
      if (isMobile()) return;
      if (!root.contains(e.target)) closeAllPills();
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape'){
        if (root.classList.contains('is-mobile-open')) closeSheet();
        else closeAllPills();
      }
    });

    function closeAllPills(){
      pills.forEach(function(p){
        p.classList.remove('is-open');
        var b = p.querySelector('[data-ab-toggle]');
        if (b) b.setAttribute('aria-expanded','false');
      });
    }

    // Checkbox changes
    root.querySelectorAll('input[data-ab-filter]').forEach(function(cb){
      cb.addEventListener('change', function(){
        var cat = cb.getAttribute('data-ab-filter');
        var val = cb.value;
        if (cb.checked) state[cat].add(val);
        else state[cat].delete(val);
        applyFilters();
      });
    });

    if (stockCk){
      stockCk.addEventListener('change', function(){
        state.inStock = stockCk.checked;
        applyFilters();
      });
    }

    if (clearBtn){
      clearBtn.addEventListener('click', function(){
        state.age.clear();
        state.purpose.clear();
        state.format.clear();
        state.gender.clear();
        state.inStock = false;
        root.querySelectorAll('input[data-ab-filter]').forEach(function(cb){ cb.checked = false; });
        if (stockCk) stockCk.checked = false;
        applyFilters();
      });
    }

    function productMatches(p){
      if (state.inStock && !p.available) return false;
      var cats = ['age','purpose','format','gender'];
      for (var i = 0; i < cats.length; i++){
        var cat = cats[i];
        var sel = state[cat];
        if (sel.size === 0) continue;
        var prefix = cat + ': ';
        var found = false;
        for (var j = 0; j < p.tags.length; j++){
          var t = p.tags[j];
          if (t.indexOf(prefix) !== 0) continue;
          var v = t.substring(prefix.length);
          if (sel.has(v)) { found = true; break; }
        }
        if (!found) return false;
      }
      return true;
    }

    function applyFilters(){
      var visibleCount = 0;
      cardList.forEach(function(c){
        var ok = productMatches(c);
        c.el.classList.toggle('ab-is-hidden', !ok);
        if (ok) visibleCount++;
      });
      updatePillCounts();
      updateChips();
      updateClearVisibility();
      toggleEmptyState(visibleCount === 0 && hasActive());
    }

    function hasActive(){
      return state.age.size + state.purpose.size + state.format.size + state.gender.size > 0 || state.inStock;
    }

    function updatePillCounts(){
      var total = 0;
      pills.forEach(function(p){
        var cat = p.getAttribute('data-ab-pill');
        var count = state[cat] ? state[cat].size : 0;
        total += count;
        var badge = p.querySelector('[data-ab-count]');
        if (badge){
          if (count > 0){ badge.textContent = count; badge.hidden = false; }
          else { badge.hidden = true; }
        }
        p.classList.toggle('has-active', count > 0);
      });
      if (state.inStock) total += 1;
      if (totalCount){
        if (total > 0){ totalCount.textContent = total; totalCount.hidden = false; }
        else { totalCount.hidden = true; }
      }
    }

    function updateChips(){
      if (!chipsWrap) return;
      chipsWrap.innerHTML = '';
      var cats = ['age','purpose','format','gender'];
      var any = false;
      cats.forEach(function(cat){
        state[cat].forEach(function(val){
          any = true;
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'ab-chip';
          chip.innerHTML =
            '<span>' + escapeHtml(val) + '</span>' +
            '<svg viewBox="0 0 12 12" width="10" height="10" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
          chip.setAttribute('aria-label','Remove ' + val);
          chip.addEventListener('click', function(){
            state[cat].delete(val);
            var cb = root.querySelector('input[data-ab-filter="' + cat + '"][value="' + cssEscape(val) + '"]');
            if (cb) cb.checked = false;
            applyFilters();
          });
          chipsWrap.appendChild(chip);
        });
      });
      chipsWrap.hidden = !any;
    }

    function updateClearVisibility(){
      if (!clearBtn) return;
      clearBtn.hidden = !hasActive();
    }

    function toggleEmptyState(show){
      var empty = root.querySelector('.ab-topfilter__empty');
      if (!empty){
        if (!show) return;
        empty = document.createElement('div');
        empty.className = 'ab-topfilter__empty';
        empty.textContent = 'لا توجد منتجات مطابقة للفلاتر المحددة.';
        root.appendChild(empty);
      }
      empty.classList.toggle('is-visible', show);
    }

    function escapeHtml(s){
      return String(s).replace(/[&<>"']/g, function(c){
        return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
      });
    }

    function cssEscape(s){
      if (window.CSS && window.CSS.escape) return window.CSS.escape(s);
      return String(s).replace(/["\\]/g, '\\$&');
    }
  });
})();
